<template>
 <div class="table">
   <a-table
       :columns="columns"
       :row-key="selectRowKey"
       :data-source="listData.list"
       :loading="listData.loading"
       :rowSelection="rowSelection"
       :rowClassName="(_, index) => (index % 2 === 1 ? 'table-striped' : null)"
       :pagination="false"
       size="small"
       @change="onChange"
       :bordered="true"
   >
   </a-table>
 </div>
</template>
<script setup lang="ts">
import {ColumnType} from "ant-design-vue/lib/table/interface";

const props = defineProps<{
  // 数据
  listData: { list: unknown[]; loading: boolean; };
  // 列配置
  columns: ColumnType[];
  rowSelection?: {fix: boolean; selectedRowKeys: string[]; onChange:  (rowKeys: any[], rows: any[]) => void}
  selectRowKey?: string;
}>();

const emit = defineEmits<{
  (event: "change", pagination: any, filters: any, sorter: any): void;
}>();

function onChange(pagination: any, filters: any, sorter: any) {
  emit("change", pagination, filters, sorter);
}

</script>

<style lang="scss" scoped>
.table {
  margin: $spacing-medium 0;
  overflow: auto;
  :deep(table) {
    width: max-content;
    min-width: 100%;
  }
  :deep(.table-striped) {
    background-color: #fafafa;
  }
}

</style>
